import { Component, OnInit } from '@angular/core';
import { AuthTokenService } from '../services/auth-token.service';

@Component({
  selector: 'app-auth-start',
  standalone: true,
  template: '<p role="status">{{ statusMessage }}</p>'
})
export class AuthStartComponent implements OnInit {
  statusMessage = 'Redirecting to sign in...';

  constructor(private readonly authTokenService: AuthTokenService) {}

  /**
   * Starts REM authentication; Cognito reuses the first application's Hosted UI session.
   */
  ngOnInit(): void {
    void this.authTokenService.startLogin('/').catch(() => {
      this.statusMessage = 'Authentication is not configured. Contact support.';
    });
  }
}